import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProgressBarItem",
  props: {
    step: {
      type: [String, Object],
      required: true
    },
    stepIndex: {
      type: Number,
      required: true
    },
    customRender: {
      type: Boolean,
      required: true
    },
    selectedSteps: {
      type: [Array, String],
      default: ""
    }
  },
  data() {
    return {
      TEXT_LIMIT: 20
    };
  },
  computed: {
    statusItemClass() {
      const current = this.selected;
      return {
        current
      };
    },
    selected() {
      return this.stepValue.selected;
    },
    stepValue() {
      const step = typeof this.step === "string" ? {
        id: this.stepIndex,
        stepName: this.step
      } : this.step;
      step.selected = this.isItemSelected(step);
      return step;
    },
    tooltipText() {
      return this.customRender ? this.step.stepName : this.step.value;
    }
  },
  methods: {
    getItemClass() {
      return {};
    },
    isItemSelected(step) {
      var _context2;
      if (Array.isArray(this.selectedSteps)) {
        var _context;
        return _includesInstanceProperty(_context = this.selectedSteps).call(_context, step.id);
      }
      return _includesInstanceProperty(_context2 = [step.stepName, step.id]).call(_context2, this.selectedSteps);
    },
    handleStatusClick() {
      this.$emit("select-status", {
        id: this.stepValue.id,
        selected: !this.selected
      });
    }
  }
});